jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Card link drawers
  //############################################//

  const mq = window.matchMedia("(min-width: 768px)");
  if (mq.matches) {
    $(".profile-link").hover(
      function () {
        $(".text-float", this)
          .stop(true, true)
          .delay(100)
          .animate({ bottom: "0" }, 200)
          .addClass("open");
      },
      function () {
        $(".text-float", this)
          .stop(true, true)
          .delay(100)
          .animate({ bottom: "-41" }, 200)
          .removeClass("open");
      }
    );

    $(".c-expert__content-mobile").remove();

    $(".c-expert__set .profile-link").click(function () {
      var id = $(this).data("slideContent");
      var expertContent = $(this).data("expert-container");

      $(".c-expert__content-desktop .profile-box").slideUp();

      if (!$(this).hasClass("active")) {
        $(".active").removeClass("active");
        $(this).addClass("active");
        $("#" + id).slideDown();
      } else $(this).removeClass("active");
    });

    $(".close-btn").click(function () {
      $(".active").removeClass("active");
      $(".profile-box").slideUp();
    });
  } else {
    //Our Experts
    $(".c-expert__set .profile-link").click(function () {
      var id = $(this).data("slideContent");
      var expertContent = $(this).data("expert-container");

      $(".c-expert__content-mobile .profile-box").slideUp();

      if (!$(this).hasClass("active")) {
        $(".active").removeClass("active");
        $(this).addClass("active");
        $("#" + id).slideDown();
      } else $(this).removeClass("active");
    });

    $(".close-btn").click(function () {
      $(".active").removeClass("active");
      $(".profile-box").slideUp();
    });
  }
});
